<script setup lang="ts">
import VDropDown from "@/scripts/components/app/common/VDropDown.vue";

interface Props {
    identifier: string;
}

const props = defineProps<Props>();

const getDownloadPathForQrCode = (format) => {
    return `/api/qrcode/download?identifier=${props.identifier}&format=${format}`
}

const items = [
    {link: getDownloadPathForQrCode('png'), title: 'PNG'},
    {link: getDownloadPathForQrCode('pdf'), title: 'PDF'},
    {link: getDownloadPathForQrCode('svg'), title: 'SVG'},
    {link: getDownloadPathForQrCode('jpg'), title: 'JPG'},
]

</script>

<template>
    <v-drop-down title="Скачать" :items="items"></v-drop-down>
</template>

<style scoped>

</style>